var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":"Client Title","outlined":_vm.outlined,"dense":_vm.dense,"items":_vm.items,"item-text":"title","item-value":"title","clearable":_vm.clearable},on:{"change":_vm.onChange},model:{value:(_vm.selectedClientTitle),callback:function ($$v) {_vm.selectedClientTitle=$$v},expression:"selectedClientTitle"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-330bc147","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gt/shared/ClientTitleListSelect.vue
// module id = null
// module chunks = 